import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'dialog-eula',
  templateUrl: './dialog-eula.component.html',
  styleUrls: ['./dialog-eula.component.scss']
})
export class DialogEulaComponent implements OnInit, AfterViewInit {
  @ViewChild('eulaContent') eulaContent!: ElementRef;
  scrolledToBottom = false;
  
  constructor(public dialogRef: MatDialogRef<DialogEulaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,) { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.eulaContent.nativeElement.addEventListener('scroll', this.checkScroll.bind(this));
  }

  checkScroll() {
    const element = this.eulaContent.nativeElement;
    if (element.scrollHeight - element.scrollTop <= element.clientHeight + 1) { 
      this.scrolledToBottom = true;
    }
  }

  confirm() {
    const eulaContentText = this.eulaContent.nativeElement.innerText.trim();

    this.dialogRef.close({
      status: 'scrolledToBottom',
      content: eulaContentText
    });
  }
}
